import React from 'react';
import { useAuth } from '../../hooks/useAuth';

const SortableHeader = ({ label, field, sortField, sortOrder, onSort }) => {
  const isActive = sortField === field;
  const arrow = isActive ? (sortOrder === 'asc' ? ' ▲' : ' ▼') : '';
  
  return (
    <th 
      onClick={() => onSort(field)}
      style={{ cursor: 'pointer', userSelect: 'none' }}
      title={`Click to sort by ${label}`}
    >
      {label}{arrow}
    </th>
  );
};

const PlotList = ({ plots, onEdit, onDelete, onSort, sortField, sortOrder }) => {
  const { isAdmin } = useAuth();

  const getStatusClass = (status) => {
    return `status-badge status-${status}`;
  };

  if (!plots || plots.length === 0) {
    return (
      <div className="card">
        <p style={{ textAlign: 'center', color: '#666' }}>No plots found.</p>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="table-responsive">
      <table className="data-table">
        <thead>
          <tr>
            <SortableHeader 
              label="Plot Number" 
              field="plot_number" 
              sortField={sortField}
              sortOrder={sortOrder}
              onSort={onSort}
            />
            <SortableHeader 
              label="Section" 
              field="section" 
              sortField={sortField}
              sortOrder={sortOrder}
              onSort={onSort}
            />
            <th>Location (Row/Col)</th>
            <th>Coordinates</th>
            <th>Status</th>
            <th>Occupant</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {plots.map(plot => (
            <tr key={plot.id}>
              <td><strong>{plot.plot_number}</strong></td>
              <td>{plot.section || '-'}</td>
              <td>
                {plot.row_number && plot.column_number 
                  ? `R${plot.row_number} / C${plot.column_number}`
                  : '-'
                }
              </td>
              <td>
                <small>
                  {parseFloat(plot.latitude).toFixed(6)},
                  <br />
                  {parseFloat(plot.longitude).toFixed(6)}
                </small>
              </td>
              <td>
                <span className={getStatusClass(plot.status)}>
                  {plot.status}
                </span>
              </td>
              <td>
                {plot.burial_record ? (
                  <span>{plot.burial_record.deceased_name}</span>
                ) : (
                  <span style={{ color: '#999' }}>-</span>
                )}
              </td>
              <td>
                <div className="btn-group">
                  <button
                    className="btn btn-sm"
                    onClick={() => onEdit(plot)}
                  >
                    Edit
                  </button>
                  {isAdmin && !plot.burial_record && (
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => onDelete(plot.id)}
                    >
                      Archive
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
};

export default PlotList;
